module Sm.UI.Clock

open System
open Browser
open MobF

type Interval =
    | Seconds
    | Minutes

type ITimer =
    inherit IDisposable
    abstract Start: Interval -> unit
    abstract Stop: unit -> unit
    abstract Tick: (unit -> unit) with get, set

let backgroundTimer () =
    let mutable tickHandler = id
    let worker = Worker.Create("timer.js")

    worker.onmessage <- fun m ->
        match string m.data with
        | "tick" -> tickHandler()
        | _ -> ()

    { new ITimer with
        member _.Start(interval) = 
            match interval with
            | Seconds -> worker.postMessage("start-seconds")
            | Minutes -> worker.postMessage("start-minutes")

        member _.Stop() = worker.postMessage("stop")

        member _.Tick 
            with get() = tickHandler 
            and set v = tickHandler <- v

        member _.Dispose() = 
            worker.terminate()
            tickHandler <- id
    }

type State = {
    CurrentTime: DateTime
    CurrentHour: DateTime
}

type Msg =
    | Tick

type ClockType = Model<State, Msg>

let create () : ClockType =
    let hour () =
        let now = DateTime.Now
        DateTime(now.Year, now.Month, now.Day, now.Hour, minute = 0, second = 0)

    let init () =
        {
            CurrentTime = DateTime.Now
            CurrentHour = hour ()
        }

    let update state = function
        | Tick ->
            let nextHour = hour ()
            { state with 
                CurrentTime = DateTime.Now
                CurrentHour =
                    if state.CurrentHour = nextHour then state.CurrentHour
                    else nextHour
            }

    Model.useInit init
    |> Model.andUpdate update
    |> Model.create
